import React from "react";
import PropTypes from "prop-types";
import { TextDisplay } from "..";
import styles from "./styles/email-display.css.js";
import withStyles from "components/with-styles";

const EmailDisplay = ({ email, classes, ...props }) => {
  if (!email) {
    return null;
  }

  return (
    <TextDisplay icon="email" className={classes.emailDisplay} {...props}>
      <a target="_blank" rel="noopener noreferrer" href={`mailto:${email}`} className={classes.emailDisplay__link}>
        {email}
      </a>
    </TextDisplay>
  );
};

EmailDisplay.propTypes = {
  /**
   * Email a mostrar
   **/
  email: PropTypes.string,
};

export default withStyles(styles)(EmailDisplay);
